<template>
  <div v-if="streamError" class="spinner-overlay" :style="{ height }">
    <stream-error :message="streamError" @retry="retryStream" />
  </div>
  <div v-else-if="isLoading" class="spinner-overlay" :style="{ height }">
    <spinner-component />
    <div class="spinner-text">
      {{ iceState ? iceStateMessage : 'Waiting For connection...' }}
    </div>
  </div>
  <video
    v-show="!isLoading && !streamError"
    ref="video"
    class="w-100"
    :style="{ height }"
    autoplay
    playsinline
    muted
    controls
  />
</template>
<script>
import SpinnerComponent from '../../../shared/Components/Spinner';
import StreamError from '../../../shared/Components/StreamError.vue';
import httpClient from '@/service/httpClient';
import liveStream from 'src/mixins/liveStream';
import { MediaRTCConnection } from '../devices/ProjectiorRegion/webrtc';
import { mapGetters } from 'vuex';

export default {
  components: { SpinnerComponent, StreamError },
  mixins: [liveStream],
  inject: ['toast'],
  props: {
    serialNumber: { type: String, default: null },
    deviceSettings: { type: Object, default: () => ({}) },
    // CSS height of the player; the parent can pass e.g. '100%' to embed it.
    height: { type: String, default: '600px' }
  },
  emits: ['closeModal', 'connected', 'failed'],
  data() {
    return {
      video: null,
      videoParams: null,
      cssPhysicalProportion: 1,
      videoWidth: 640,
      rtcConfiguration: {},
      deviceMac: null,
      isLoading: true,
      rtcConn: null,
      answerSearching: null,
      iceState: null,
      iceStateMessage: null,
      mediaConnection: null,
      answerHandler: null
    };
  },
  computed: {
    ...mapGetters(['organization', 'fcmToken'])
  },
  watch: {
    iceState(value) {
      console.log('ice state->', value);
      if (value === 'failed') {
        console.log('icestate failed', value);
        this.iceStateMessage = 'Live Stream Failed';
        this.$emit('failed', this.iceStateMessage);
        this.$emit('closeModal');
      } else if (value === 'disconnected') {
        console.log('icestate disconnected', value);
        // this.isLoading = true;
        // this.iceStateMessage = 'Slow network detected. Trying to reconnect...';
        // this.toast.info('Slow network detected. Trying to reconnect...');
      } else if (value === 'connected') {
        this.iceStateMessage = 'Live Stream Connected';
        this.isLoading = false;
        this.$emit('connected');
      } else if (value === 'checking') {
        this.isLoading = true;
        this.iceStateMessage = 'Checking For Connection...';
      }
    }
  },
  created() {
    this.deviceMac = this.serialNumber;
  },
  mounted() {
    this.video = this.$refs.video;
    this.video.addEventListener('canplay', () => {
      this.play();
    });
    this.startStream();
  },
  beforeUnmount() {
    // The liveStream mixin closes the connection.
    clearInterval(this.answerSearching);
  },
  methods: {
    play() {
      // Rejects if the stream is torn down before playback starts.
      this.video.play()?.catch(() => {});
    },
    // Called by the liveStream mixin for each attempt.
    async connectStream(attempt) {
      const rtcConfiguration = await this.loadStreamServers(
        this.deviceSettings?.ice_options
      );
      if (!this.isCurrentStreamAttempt(attempt)) return;
      this.rtcConfiguration = rtcConfiguration;
      const connection = new MediaRTCConnection(
        this.serialNumber,
        this.organization,
        this.fcmToken,
        this.video,
        this.rtcConfiguration,
        this.setIceState
      );
      connection.onFailure = (message) => this.failStream(attempt, message);
      this.mediaConnection = connection;
      // The answer can also arrive by push; this handler belongs to this
      // connection only and is removed when it is closed.
      this.answerHandler = connection.setRTCRemoteDescription.bind(connection);
      this.emitter.on(this.serialNumber, this.answerHandler);
      await connection.connectToRemotePeer();
    },
    closeStreamConnections() {
      if (this.answerHandler) {
        this.emitter.off(this.serialNumber, this.answerHandler);
        this.answerHandler = null;
      }
      this.mediaConnection?.close();
      this.mediaConnection = null;
    },
    onStreamFailed(message) {
      this.$emit('failed', message);
    },
    setIceState: function(value) {
      console.log('ice state', value);
      this.iceState = value;
    },
    setVideoParams() {
      const self = this;
      const modalBody = document.getElementById('stream-modal-body');
      setTimeout(() => {
        const { top, left, width, height } = self.video.getBoundingClientRect();
        const modalParams = modalBody?.getBoundingClientRect();
        self.videoParams = {
          top: Math.floor(top - modalParams.top),
          left: Math.floor(left - modalParams.left),
          width: Math.floor(width),
          height: Math.floor(height)
        };
        self.cssPhysicalProportion = self.videoWidth / width;
      }, 2000);
    }
  }
};
</script>
<style scoped>
.video-container {
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.spinner-overlay {
  /* position: absolute; */
  top: 0;
  left: 0;
  width: 100%;
  height: 600px;
  /* Semi-transparent background for the overlay */
  /* background: rgba(
    255,
    255,
    255,
    0.8
  );  */
  display: flex;
  justify-content: center;
  align-items: center;
  /* z-index: 1;  */
  text-align: center;
  flex-direction: column;
}
.spinner-text {
  margin-top: 10px; /* Add some spacing between the spinner and text */
}
</style>
